export default [
	{
		path: '/jobs/gaming-job-suggestions',
		name: 'jobs-gaming-job-suggestions',
		component: () => import('@/views/jobs/gaming-job-suggestions/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,vacancies',
		},
	},
]
